const bannerlist = [
    {
        id: 1,
        bannerimg: require("@/assets/images/banner1.png"),
        bannertext: "璀璨奢华，尽享绝妙时刻——探索至臻奢华住宿体验"
    },
    {
        id: 2,
        bannerimg: require("@/assets/images/banner2.png"),
        bannertext: "极尽奢华——探索绝美酒店房间，沉浸奢华之境"
    },
    {
        id: 3,
        bannerimg: require("@/assets/images/banner3.png"),
        bannertext: "奢逸尊享——追寻高级住宿的璀璨绝妙时刻"
    },
    {
        id: 4,
        bannerimg: require("@/assets/images/banner4.png"),
        bannertext: "华丽之选——绝美酒店房间，享受至尊奢华的居住体验"
    },
    {
        id: 5,
        bannerimg: require("@/assets/images/banner5.png"),
        bannertext: "奢华至极——沉浸顶级住宿，享受独一无二的奢华体验"
    },
    {
        id: 6,
        bannerimg: require("@/assets/images/banner6.png"),
        bannertext: "尊贵奢华——探索顶级酒店，感受绝妙时刻的璀璨魅力"
    },
    {
        id: 7,
        bannerimg: require("@/assets/images/banner7.png"),
        bannertext: "极致精品——追求卓越住宿，品味至高奢华的非凡之旅"
    }, {
        id: 8,
        bannerimg: require("@/assets/images/banner8.png"),
        bannertext: "奢华梦幻——探索高级住宿的迷人魅力，享受璀璨体验"
    },
    {
        id: 9,
        bannerimg: require("@/assets/images/banner9.png"),
        bannertext: "尊崇至极——尽情沉浸于至臻高级住宿，领略奢华生活"
    },
    {
        id: 10,
        bannerimg: require("@/assets/images/banner3.png"),
        bannertext: "非凡奢享——探寻独具匠心的酒店房间，享受华丽体验"
    },



];

export {
    bannerlist

}



